import { FC } from "react";
import { Button } from "antd";

import styles from "../../index.less";

import { ServicePaymentAgreementUrl } from "../../../../../../constants";

interface WaitingForAgreeTermsProps {
  handleAgreeTerms: () => void;
}

const WaitingForAgreeTerms: FC<WaitingForAgreeTermsProps> = ({
  handleAgreeTerms,
}) => {
  return (
    <div className={styles["waiting-for-agree-terms"]}>
      <div className={styles.agree}>
        <div className={styles.text}>支付前请阅读</div>
        <a
          className={styles["link"]}
          onClick={() => {
            window.open(ServicePaymentAgreementUrl, "_blank");
          }}
        >
          《服务支付协议》
        </a>
      </div>
      <Button type="primary" onClick={handleAgreeTerms}>
        同意并支付
      </Button>
    </div>
  );
};

export default WaitingForAgreeTerms;
